import { css } from 'linaria';

export const paddingY = css`
  padding-top: var(--space-200);
  padding-bottom: var(--space-200);
`;

export const paddingX = css`
  padding-left: var(--space-400);
  padding-right: var(--space-400);

  @media (--to-tablet) {
    padding-right: var(--space-300);
    padding-left: var(--space-300);
  }
`;

export const hoverLayout = css`
  position: relative;

  @media (hover: hover) {
    &:hover {
      &::after {
        position: absolute;
        top: 0;
        z-index: -1;
        display: block;
        width: 100%;
        height: 100%;
        background-color: var(--background-secondary);
        content: '';
      }
    }
  }
`;

export const focusLayout = css`
  position: relative;

  &::after {
    position: absolute;
    top: 0;
    z-index: -1;
    display: block;
    width: 100%;
    height: 100%;
    background-color: var(--background-secondary);
    content: '';
  }
`;
